import {Box, Card} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {memo} from 'react'
import baseStyles from '../../styles/base.module.css'
import type {CustomerStory} from '../../types'

function LogoStoryCardComponent({story}: {story: CustomerStory}) {
  const {logo, lead, url, title} = story.fields

  return (
    <Box
      className={clsx(baseStyles.gridItem, baseStyles.stackedCardGridItem)}
      padding={{narrow: 24, regular: 40}}
      paddingInlineStart={{narrow: 24, regular: 80, wide: 64}}
      paddingInlineEnd={{narrow: 24, regular: 80, wide: 64}}
      paddingBlockStart={{regular: 80}}
      paddingBlockEnd={{regular: 80}}
    >
      <Card href={url} variant="minimal" fullWidth ctaVariant="arrow">
        <Card.Image
          src={`${logo.fields.file.url}?fm=webp&h=60`}
          alt={logo.fields.description || title}
          style={{height: '30px', width: 'auto', objectFit: 'contain'}}
        />
        <Card.Heading>{title}</Card.Heading>
        <Card.Description>{lead}</Card.Description>
      </Card>
    </Box>
  )
}

export const LogoStoryCard = memo(LogoStoryCardComponent)
LogoStoryCard.displayName = 'LogoStoryCard'
